import { Quaternion, Vector2, Vector3 } from 'three';
import { truncateToPoint2D } from '../../../cross-team-shared/misc-utils';
import {
  Point2D,
  Point3D,
} from '../../../team-apis/otterdam/answers/shape-typings';
import { XYZWQuaternionTuple } from '../../../team-apis/otterdam/calibration-data';
import { REFERENCE_AXIS } from '../../utils/point-cloud-utils';
import { isPointCloseTo, subtractPoints } from '../../utils/point-utils';

const referenceAxis = new Vector3();
const sensorQuaternion = new Quaternion();

export function getXYDirectionToObject(
  objectPosition: Point3D,
  referencePosition: Point3D,
) {
  const directionToObject = subtractPoints(objectPosition, referencePosition);

  return truncateToPoint2D(directionToObject);
}

export function getSensorDirection(rotation: XYZWQuaternionTuple) {
  return truncateToPoint2D(
    referenceAxis
      .fromArray(REFERENCE_AXIS)
      .applyQuaternion(sensorQuaternion.fromArray(rotation))
      .toArray(),
  );
}

const reUsableReference = new Vector2();
const reUsableSubject = new Vector2();

export function angleBetween(
  reference: Point2D,
  subject: Point2D,
  collinearMethod: 'NaN' | 'Disambiguate' = 'NaN',
) {
  if (isPointCloseTo(reference, subject)) {
    return 0;
  }

  const referenceVector = reUsableReference.fromArray(reference);
  const subjectVector = reUsableSubject.fromArray(subject);

  const relativePosition = referenceVector.cross(subjectVector);
  const collinearCoefficient = referenceVector.dot(subjectVector);

  if (relativePosition === 0) {
    const areVectorsOpposite = collinearCoefficient > 0;
    const disambiguatedAngle = areVectorsOpposite ? Math.PI : 0;

    return collinearMethod === 'NaN' ? NaN : disambiguatedAngle;
  }

  return Math.atan2(relativePosition, collinearCoefficient);
}
